module.exports = __webpack_public_path__ + "static/media/TanTaat.6f01eb9f.jpg";